export default (fn) => (event) => {
  event.preventDefault();
  return fn(event);
};
